import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { TextField, Typography } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
    root: {
        paddingBottom: "20px"
    }
}));

const UDFText = (props) => {
    const { UDF } = props;
    const classes = useStyles();

    const onChangeHandler = (event) => {
        props.changecontrolvalue(event, props.bookingID, UDF.UDFCategoryName, UDF.UDFID);
    }

    const GetUserMemberValue = () => {
        if (props.isMembership) {
            let userV = "";

            if (UDF.Users.filter(x => x.userID == props.usernumber).length > 0) {
                let user = UDF.Users.find(x => x.userID == props.usernumber);

                if (user && user.hasOwnProperty('userUDFValue')) {
                    userV = user.userUDFValue;
                }

                return userV;
            }
        }
        else {
            return UDF.Value;
        }
    }
    return (
        <div className={classes.root}>
            <Typography variant="subtitle1">{UDF.UdfDescription}</Typography>
            <TextField
                data={UDF}
                id={UDF.UDFID.toString()}
                name={UDF.UDFName.toString()}
                label={UDF.UDFName}
                required={UDF.IsRequired}
                multiline={UDF.UDFLength && UDF.UDFLength > 200}
                inputProps={{ maxLength: UDF.UDFLength }}
                onChange={onChangeHandler}
                value={GetUserMemberValue()}
                {...props}
                sx={{ p: 4, '& .MuiInputLabel-root': { p: 4 } }}
                variant="standard"
                InputLabelProps={{
                    style: { padding: "0 0 0 15px"  }
                }}
            />
        </div>
    );
};

UDFText.propTypes = {
    udf: PropTypes.object.isRequired
};

export default UDFText;
